/* eslint-disable react/jsx-wrap-multilines */
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Divider,
  InputAdornment,
  OutlinedInput,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getHistories,
  sendCommand,
  setCommand,
} from '../../modules/historyBot';
import HistoryList from '../../components/history/HistoryList';

let timeout;
const HistoryListContainer = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.historyBot);
  const { historyList, selectedRobot, command, pending } = selector;
  const [value, setValue] = useState('');

  const handleSendClick = () => {
    if (!pending) {
      dispatch(setCommand(value));
      dispatch(sendCommand(value));
    }
  };

  const handleKeyChange = ({ key, keyCode }) => {
    if (key === 'Enter' || keyCode === 13) {
      handleSendClick();
    }
  };

  const handleTimeoutInput = () => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      dispatch(setCommand(value));
    }, 500);
  };

  const handleTextChange = (e) => {
    setValue(e.target.value);
    handleTimeoutInput();
  };

  const handleLoad = () => dispatch(getHistories(selectedRobot.id));

  useEffect(() => {
    setValue('');
    if (selectedRobot) {
      const { id } = selectedRobot;
      dispatch(getHistories(id));
    }
  }, [selectedRobot]);

  useEffect(() => {
    if (!command) {
      setValue(command);
    }
  }, [command]);

  return (
    <Box>
      {selectedRobot && (
        <Card variant="outlined">
          <CardContent
            sx={{ minHeight: '544px', display: 'flex', pr: 0, pb: 0 }}
          >
            <HistoryList
              {...{
                data: historyList,
                robot: selectedRobot,
                pending,
                handleLoad,
                bTop: !!command,
              }}
            />
          </CardContent>
          <Divider sx={{ width: '100%' }} />
          <CardActions>
            <OutlinedInput
              id="outlined-adornment-input"
              type="text"
              value={value}
              disabled={pending || (selectedRobot && !selectedRobot.connect)}
              placeholder={
                selectedRobot.connect
                  ? '전달할 명령어를 입력하세요.'
                  : '로봇의 전원을 켜고 입력하세요.'
              }
              onBlur={handleTimeoutInput}
              onChange={handleTextChange}
              onKeyDown={handleKeyChange}
              endAdornment={
                <InputAdornment position="end">
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleSendClick}
                    disabled={
                      pending ||
                      (selectedRobot && !selectedRobot.connect) ||
                      !value
                    }
                    sx={{ p: 0.5 }}
                  >
                    {pending ? (
                      <CircularProgress
                        color="secondary"
                        size="small"
                        sx={{ width: '1rem' }}
                      />
                    ) : (
                      '전송'
                    )}
                  </Button>
                </InputAdornment>
              }
              fullWidth
            />
          </CardActions>
        </Card>
      )}
    </Box>
  );
};

export default HistoryListContainer;
